import { render, staticRenderFns } from "./AppraisalList.vue?vue&type=template&id=315f0526&scoped=true"
import script from "./AppraisalList.vue?vue&type=script&lang=js"
export * from "./AppraisalList.vue?vue&type=script&lang=js"
import style0 from "./AppraisalList.vue?vue&type=style&index=0&id=315f0526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315f0526",
  null
  
)

export default component.exports